/**
 * Application Routes Definition & Code Splitting (Standards 10-15)
 */

import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PageLoader } from '../../shared/ui/PageLoader';
import { DataProvider } from '../../context/DataContext';
import { ProtectedRoute } from './RouteGuard';

const LandingPage           = lazy(() => import('../../pages/LandingPage'));
const Login                 = lazy(() => import('../../pages/Login'));
const SignUp                = lazy(() => import('../../pages/SignUp'));
const ForgotPassword        = lazy(() => import('../../pages/ForgotPassword'));
const ResetPassword         = lazy(() => import('../../pages/ResetPassword'));
const PublicPortfolioScreen = lazy(() => import('../../features/profile/screens/PublicPortfolioScreen').then(m => ({ default: m.PublicPortfolioScreen })));
const AppMain               = lazy(() => import('../../AppMain').then(m => ({ default: m.AppMain })));
const Settings              = lazy(() => import('../../features/settings/screens/Settings').then(m => ({ default: m.Settings })));

export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/p/:username" element={<PublicPortfolioScreen />} />

        {/* Protected Dashboard Routes */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <DataProvider>
                <AppMain />
              </DataProvider>
            </ProtectedRoute>
          }
        />

        {/* Settings, Profile & Fallback */}
        <Route path="/profile" element={<Navigate to="/dashboard/profile" replace />} />
        <Route path="/society" element={<Navigate to="/dashboard/societies" replace />} />
        <Route path="/societies" element={<Navigate to="/dashboard/societies" replace />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};
